<app-multiple-items-with-tooltip [items]="recipients"></app-multiple-items-with-tooltip>